"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var bool = require('./bool');

var _char = require('./char');

var usize = require('./usize');

var isize = require('./isize');

var types = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, bool), _char), usize), isize);

var util = require('../util');
/**
 * Array
 */


var array = function array(_type) {
  var _this = this;

  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  _classCallCheck(this, array);

  _defineProperty(this, "_parseType", function (type) {
    if (!type) throw new Error('Invalid type array');
    if (typeof type !== 'string') throw new Error('Invalid type array');
    type = type.trim();
    type = type.split('');
    if (type.shift() !== '[') throw new Error('Invalid type array');
    if (type.pop() !== ']') throw new Error('Invalid type array');
    type = type.join('');

    var _type$split = type.split(';'),
        _type$split2 = _slicedToArray(_type$split, 2),
        primaryType = _type$split2[0],
        len = _type$split2[1];

    if (!primaryType || !len) throw new Error('Invalid type array');
    if (!types[primaryType]) throw new Error('Invalid type array');

    try {
      len = parseInt(len);
    } catch (er) {
      len = 0;
    }

    if (len <= 0) throw new Error('Invalid type array');
    var space = new types[primaryType]().space * len;
    return {
      primaryType: primaryType,
      space: space
    };
  });

  _defineProperty(this, "toBuffer", function () {
    var eleBufs = _this.value.map(function (item) {
      return new types[_this._primaryType](item);
    });

    return util.pack.apply(util, _toConsumableArray(eleBufs));
  });

  _defineProperty(this, "fromBuffer", function (buf) {
    if (!Buffer.isBuffer(buf)) throw new Error('Invalid buffer');
    _this.value = [];
    var offset = 0;

    while (offset < _this.space) {
      var type = new types[_this._primaryType]();
      type.fromBuffer(buf.slice(offset, offset + type.space));

      _this.value.push(type.value);

      offset += type.space;
    }
  });

  this.value = value;
  this.type = _type;

  var _this$_parseType = this._parseType(this.type),
      _primaryType = _this$_parseType.primaryType,
      _space = _this$_parseType.space;

  this._primaryType = _primaryType;
  this.space = _space;
};

module.exports = {
  array: array
};